// Components/redux/cartItemsSlice.js
import { createSlice } from "@reduxjs/toolkit";

const cartItemsSlice = createSlice({
  name: "cartItems",
  initialState: {
    items: [] // Her ürün: { product_id, quantity }
  },
  reducers: {
    // Tüm sepeti backend'den gelenle ayarla
    setCartItems: (state, action) => {
      state.items = action.payload;
    },

    // Sepete ürün ekle (varsa miktarını artır)
    addCartItem: (state, action) => {
      const existing = state.items.find(item => item.product_id === action.payload.product_id);
      if (existing) {
        existing.quantity += action.payload.quantity;
      } else {
        state.items.push(action.payload);
      }
    },

    // Ürünü sepetten kaldır
    removeCartItem: (state, action) => {
      state.items = state.items.filter(item => item.product_id !== action.payload);
    },

    // Miktarı güncelle
    updateCartItemQuantity: (state, action) => {
      const { product_id, quantity } = action.payload;
      const item = state.items.find(item => item.product_id === product_id);
      if (item) {
        item.quantity = quantity;
      }
    },

    // Sepeti tamamen temizle
    clearCart: (state) => {
      state.items = [];
    }
  }
});

export const {
  setCartItems,
  addCartItem,
  removeCartItem,
  updateCartItemQuantity,
  clearCart
} = cartItemsSlice.actions;

export default cartItemsSlice.reducer;
